// Local (the data comes from the local database):
// export const RootAPIURL = 'http://localhost:8000/api/v1/';
// Or:
// export const RootAPIURL = 'http://192.168.0.118:8000/api/v1/';

// TODO:
// Development (the data comes from the development database on the server):
// export const RootAPIURL = 'https://tutoring-development.helpyourmath.com/api/v1/';

// Production (the data comes from the production database on the server):
export const RootAPIURL = 'https://tutoring.helpyourmath.com/api/v1/';
